var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7207 16.4542L8.34084 17.151V16.2398L8.55472 16.0254H10.0519V17.0974V17.8477H8.44778L6.46931 16.9902L5.7207 16.4542Z",
    fill: "#CDBDB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2764 16.4542L11.7097 17.151V16.2398L11.4958 16.0254H9.9986V17.0974V17.8477H11.6028L13.5812 16.9902L14.2764 16.4542Z",
    fill: "#CDBDB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5552 14.4711L8.34131 16.2399L8.60867 16.0255H11.3892L11.71 16.2399L11.4962 14.4711L11.0684 14.2031L8.9295 14.2567L8.5552 14.4711Z",
    fill: "#393939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.1123 2.51953L8.39563 5.52105L8.98383 14.2576H11.0692L11.7109 5.52105L12.8873 2.51953H7.1123Z",
    fill: "#F89C35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.49722 9.11186L0 13.4533L3.74305 13.2389H6.14929V11.363L6.04234 7.50391L5.50762 7.93269L1.49722 9.11186Z",
    fill: "#F89D35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33154 9.59375L8.71625 9.70095L8.235 11.9521L6.14959 11.4161L4.33154 9.59375Z",
    fill: "#D87C30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.33154 9.64844L6.14959 11.3636V13.0787L4.33154 9.64844Z",
    fill: "#EA8D3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.1499 11.416L8.28879 11.952L8.98392 14.2567L8.50267 14.5247L6.1499 13.1312V11.416Z",
    fill: "#F89D35"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.14848 13.1309L5.7207 16.454L8.55472 14.4708L6.14848 13.1309Z",
    fill: "#EB8F35"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.71636 9.70117L8.98372 14.257L8.18164 11.9255L8.71636 9.70117Z",
    fill: "#EA8E3A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.68896 13.1845L6.14868 13.1309L5.7209 16.454L3.68896 13.1845Z",
    fill: "#D87C30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.17639 17.9022L5.72151 16.4551L3.68957 13.1855L0 13.4535L1.17639 17.9022Z",
    fill: "#EB8F35"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39542 5.52148L6.09612 7.45103L4.33154 9.59497L8.71625 9.75576L8.39542 5.52148Z",
    fill: "#E8821E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7207 16.4538L8.55472 14.4707L8.34083 16.1859V17.1506L6.41584 16.7754L5.7207 16.4538Z",
    fill: "#DFCEC3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2764 16.4538L11.4958 14.4707L11.7097 16.1859V17.1506L13.6347 16.7754L14.2764 16.4538Z",
    fill: "#DFCEC3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.53974 10.666L8.12793 11.8988L6.04252 11.3628L7.53974 10.666Z",
    fill: "#393939"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.12305 0L8.39525 5.52064L7.16539 2.51913L1.12305 0Z",
    fill: "#E88F35"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.12265 0L0.160156 2.94792L0.694877 6.16383L0.320572 6.37822L0.855293 6.86061L0.427517 7.2358L1.01571 7.77178L0.641405 8.09337L1.49696 9.16534L5.50736 7.93258C7.46801 6.36035 8.4305 5.55638 8.39486 5.52064C8.35921 5.48491 5.93514 3.6447 1.12265 0Z",
    fill: "#8E5A30"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5028 9.11186L20 13.4533L16.257 13.2389H13.8507V11.363L13.9577 7.50391L14.4924 7.93269L18.5028 9.11186Z",
    fill: "#F89D35"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6685 9.59375L11.2837 9.70095L11.765 11.9521L13.8504 11.4161L15.6685 9.59375Z",
    fill: "#D87C30"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6685 9.64844L13.8504 11.3636V13.0787L15.6685 9.64844Z",
    fill: "#EA8D3A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8501 11.416L11.7112 11.952L11.0161 14.2567L11.4973 14.5247L13.8501 13.1312V11.416Z",
    fill: "#F89D35"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8515 13.1309L14.2793 16.454L11.4987 14.5244L13.8515 13.1309Z",
    fill: "#EB8F35"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2836 9.70117L11.0163 14.257L11.8184 11.9255L11.2836 9.70117Z",
    fill: "#EA8E3A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.311 13.1845L13.8513 13.1309L14.2791 16.454L16.311 13.1845Z",
    fill: "#D87C30"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8236 17.9022L14.2785 16.4551L16.3104 13.1855L20 13.4535L18.8236 17.9022Z",
    fill: "#EB8F35"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6046 5.52148L13.9039 7.45103L15.6685 9.59497L11.2837 9.75576L11.6046 5.52148Z",
    fill: "#E8821E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4603 10.666L11.8721 11.8988L13.9575 11.3628L12.4603 10.666Z",
    fill: "#393939"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.877 0L11.6048 5.52064L12.8346 2.51913L18.877 0Z",
    fill: "#E88F35"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8773 0L19.8398 2.94792L19.3051 6.16383L19.6794 6.37822L19.1447 6.86061L19.5725 7.2358L18.9843 7.77178L19.3586 8.09337L18.503 9.16534L14.4926 7.93258C12.532 6.36035 11.5695 5.55638 11.6051 5.52064C11.6408 5.48491 14.0649 3.6447 18.8773 0Z",
    fill: "#8E5A30"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.6b29d397a0b213d7f0cdc95a22528d4f.svg";
export { ForwardRef as ReactComponent };